import React, { useState, useEffect } from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import { RadioButton } from 'react-native-paper';
import AsyncStorage from '@react-native-async-storage/async-storage';

import HeaderDefault from '../../components/HeaderDefault';
import api from '../../services/api';


import styles from './styles';
import toast from '../../utils/toast';

const InvestorProfile = ({ navigation }) => {
  const [step, setStep] = useState(1);
  const [valueStep, setValueStep] = useState('');
  const [conservador, setConservador] = useState(0);
  const [moderado, setModerado] = useState(0);
  const [agressivo, setAgressivo] = useState(0);
  const [finalizado, setFinalizado] = useState(false);
  const [perfilAtual, setperfilAtual] = useState('');


  function prevStep() {
    if (step === 1) {
      navigation.navigate("Home");
      return false;
    }

    setStep(step - 1);
  }

  useEffect(() => {
    getDataUsers();
  }, []);

  const getDataUsers = async () => {
    const token = await AsyncStorage.getItem("JWT_TOKEN");
    api
      .get(`/clients/getDetails/client`, {
        headers: { Authorization: `Basic ${token}` },
      })
      .then(async (res) => {
        setFinalizado(res.data.user[0].client.is_investor_profile);
        setperfilAtual(res.data.user[0].client.investor_profile)
      })
      .catch((error) => { });
  };

  function nextStep() {

    if (valueStep)
      perfil().then(() => {

        setValueStep('');
        setStep(step + 1);

      })
    else
      toast("Selecione alguma opção", "#DA1414");

  }

  async function handleSubmit() {
    const token = await AsyncStorage.getItem('JWT_TOKEN');
    let modelPerfis = [conservador, moderado, agressivo];
    let typePerfis = ['Conservador', 'Moderado', 'Agressivo'];
    var cont = 0;
    var data, perfil;

    let maior = Math.max(conservador, moderado, agressivo);

    modelPerfis.map((e, index) => {
      if (e == maior) {
        setperfilAtual(typePerfis[index]);
        perfil = typePerfis[index];
        cont++;
      }
    });

    if (cont == 3) {
      setperfilAtual("Moderado");
      perfil = "Moderado";
    }

    data = {
      perfil: perfil,
    }

    api.post('/clients/investor/profile', data, { headers: { 'Authorization': `Basic ${token}` } })
      .then((res) => {
        setFinalizado(true);
      })
      .catch(() => {
        toast("Houve um erro, tente novamente.", "#DA1414");

      })

    //setFinalizado(true);
  }

  async function perfil() {

    switch (valueStep) {
      case '1':
        if (step === 1 || step === 2 || step === 7 || step === 9)
          setConservador(conservador + 1)

        if (step === 3 || step === 5 || step === 8)
          setAgressivo(agressivo + 3)

        if (step === 4 || step === 6)
          setModerado(moderado + 2)

        break;
      case '2':
        if (step === 2 || step === 7 || step === 8 || step === 9)
          setModerado(moderado + 2)

        if (step === 1 || step === 4)
          setAgressivo(agressivo + 3)

        if (step === 3 || step === 5 || step === 6)
          setConservador(conservador + 1)

        break;
      case '3':
        if (step === 2 || step === 6 || step === 7 || step === 9)
          setAgressivo(agressivo + 3)

        if (step === 8 || step === 4)
          setConservador(conservador + 1)

        if (step === 1 || step === 3 || step === 5)
          setModerado(moderado + 2)

        break;
    }

  }

  return (
    <>
      <HeaderDefault title={'Perfil do investidor'} />
      {!finalizado ?
        <>
          <View style={styles.container}>
            {
              step === 1 && (
                <>
                  <Text style={styles.titleStep}>1. Conhece o que é um criptoativo?</Text>
                  <RadioButton.Group onValueChange={newValue => setValueStep(newValue)} value={valueStep}>
                    <View style={styles.contentRadioButton}>
                      <RadioButton value="1" />
                      <Text style={styles.description}>Sim, mas não sou investidor.</Text>
                    </View>
                    <View style={styles.contentRadioButton}>
                      <RadioButton value="2" />
                      <Text style={styles.description}>Sim, e já invisto em criptoativo.</Text>
                    </View>
                    <View style={styles.contentRadioButton}>
                      <RadioButton value="3" />
                      <Text style={styles.description}>Não, mas quero investir.</Text>
                    </View>
                  </RadioButton.Group>
                </>
              )
            }

            {
              step === 2 && (
                <>
                  <Text style={styles.titleStep}>2. Você investiria em criptoativo que tenha lastro?</Text>
                  <RadioButton.Group onValueChange={newValue => setValueStep(newValue)} value={valueStep}>
                    <View style={styles.contentRadioButton}>
                      <RadioButton value="1" />
                      <Text style={styles.description}>Sim, prefiro criptoativo com maior segurança.</Text>
                    </View>
                    <View style={styles.contentRadioButton}>
                      <RadioButton value="2" />
                      <Text style={styles.description}>Talvez, dependendo do lastro.</Text>
                    </View>
                    <View style={styles.contentRadioButton}>
                      <RadioButton value="3" />
                      <Text style={styles.description}>Não, prefiro algum com maior rentabilidade.</Text>
                    </View>
                  </RadioButton.Group>
                </>
              )
            }

            {
              step === 3 && (
                <>
                  <Text style={styles.titleStep}>3. Você investe em criptoativo pouco conhecido?</Text>
                  <RadioButton.Group onValueChange={newValue => setValueStep(newValue)} value={valueStep}>
                    <View style={styles.contentRadioButton}>
                      <RadioButton value="1" />
                      <Text style={styles.description}>Sim.</Text>
                    </View>
                    <View style={styles.contentRadioButton}>
                      <RadioButton value="2" />
                      <Text style={styles.description}>Não.</Text>
                    </View>
                    <View style={styles.contentRadioButton}>
                      <RadioButton value="3" />
                      <Text style={styles.description}>Talvez, dependendo do projeto e lastro.</Text>
                    </View>
                  </RadioButton.Group>
                </>
              )
            }

            {
              step === 4 && (
                <>
                  <Text style={styles.titleStep}>4. Você investiria em criptoativo que tem blockchain proprietária?</Text>
                  <RadioButton.Group onValueChange={newValue => setValueStep(newValue)} value={valueStep}>
                    <View style={styles.contentRadioButton}>
                      <RadioButton value="1" />
                      <Text style={styles.description}>Sim.</Text>
                    </View>
                    <View style={styles.contentRadioButton}>
                      <RadioButton value="2" />
                      <Text style={styles.description}>Não.</Text>
                    </View>
                    <View style={styles.contentRadioButton}>
                      <RadioButton value="3" />
                      <Text style={styles.description}>Não sei o que é isso.</Text>
                    </View>
                  </RadioButton.Group>
                </>
              )
            }

            {
              step === 5 && (
                <>
                  <Text style={styles.titleStep}>5. Você aceita receber seus pagamentos, rendimentos e benefícios em criptoativos?</Text>
                  <RadioButton.Group onValueChange={newValue => setValueStep(newValue)} value={valueStep}>
                    <View style={styles.contentRadioButton}>
                      <RadioButton value="1" />
                      <Text style={styles.description}>Sim.</Text>
                    </View>
                    <View style={styles.contentRadioButton}>
                      <RadioButton value="2" />
                      <Text style={styles.description}>Não.</Text>
                    </View>
                    <View style={styles.contentRadioButton}>
                      <RadioButton value="3" />
                      <Text style={styles.description}>Talvez, dependendo do criptoativo.</Text>
                    </View>
                  </RadioButton.Group>
                </>
              )
            }

            {
              step === 6 && (
                <>
                  <Text style={styles.titleStep}>6. Selecione a frase que melhor o descreve na hora de escolher um investimento:</Text>
                  <RadioButton.Group onValueChange={newValue => setValueStep(newValue)} value={valueStep}>
                    <View style={styles.contentRadioButton}>
                      <RadioButton value="1" />
                      <Text style={styles.description}>Busco informações com agentes do mercado e de mídias especializadas.</Text>
                    </View>
                    <View style={styles.contentRadioButton}>
                      <RadioButton value="2" />
                      <Text style={styles.description}>Invisto em algo que eu conheça bem.</Text>
                    </View>
                    <View style={styles.contentRadioButton}>
                      <RadioButton value="3" />
                      <Text style={styles.description}>Investido em algo que influenciadores e mídias sociais discutem como tendências.</Text>
                    </View>
                  </RadioButton.Group>
                </>
              )
            }

            {
              step === 7 && (
                <>
                  <Text style={styles.titleStep}>7. O que você prioriza na hora de investir?</Text>
                  <RadioButton.Group onValueChange={newValue => setValueStep(newValue)} value={valueStep}>
                    <View style={styles.contentRadioButton}>
                      <RadioButton value="1" />
                      <Text style={styles.description}>Segurança e Tranquilidade.</Text>
                    </View>
                    <View style={styles.contentRadioButton}>
                      <RadioButton value="2" />
                      <Text style={styles.description}>Rentabilidade e ESG (sustentabilidade e responsabilidade social).</Text>
                    </View>
                    <View style={styles.contentRadioButton}>
                      <RadioButton value="3" />
                      <Text style={styles.description}>Rentabilidade.</Text>
                    </View>
                  </RadioButton.Group>
                </>
              )
            }

            {
              step === 8 && (
                <>
                  <Text style={styles.titleStep}>8. Como você define sua experiência com investimentos?</Text>
                  <RadioButton.Group onValueChange={newValue => setValueStep(newValue)} value={valueStep}>
                    <View style={styles.contentRadioButton}>
                      <RadioButton value="1" />
                      <Text style={styles.description}>Possuo conhecimento e experiência no mercado de criptoativos.</Text>
                    </View>
                    <View style={styles.contentRadioButton}>
                      <RadioButton value="2" />
                      <Text style={styles.description}>Possuo algum conhecimento no mercado de renda variável e de derivados.</Text>
                    </View>
                    <View style={styles.contentRadioButton}>
                      <RadioButton value="3" />
                      <Text style={styles.description}>Possuo experiência em renda fixa.</Text>
                    </View>
                  </RadioButton.Group>
                </>
              )
            }

            {
              step === 9 && (
                <>
                  <Text style={styles.titleStep}>9. Diante de precipitações da economia ou do mercado brasileiro e global que possa gerar reflexo nos seus investimentos, qual a sua atitude?</Text>
                  <RadioButton.Group onValueChange={newValue => setValueStep(newValue)} value={valueStep}>
                    <View style={styles.contentRadioButton}>
                      <RadioButton value="1" />
                      <Text style={styles.description}>Venderia imediatamente sou mais avesso ao risco.</Text>
                    </View>
                    <View style={styles.contentRadioButton}>
                      <RadioButton value="2" />
                      <Text style={styles.description}>Entendo os riscos e prefiro aguardar retomada para vender.</Text>
                    </View>
                    <View style={styles.contentRadioButton}>
                      <RadioButton value="3" />
                      <Text style={styles.description}>Procurou me antecipar as quedas e comprar mais barato.</Text>
                    </View>
                  </RadioButton.Group>
                </>
              )
            }

            {
              step === 10 && (
                <>
                  <Text style={styles.titleStep}>10. Quais suas pretensões ou montante total da sua carteira de investimentos?</Text>
                  <RadioButton.Group onValueChange={newValue => setValueStep(newValue)} value={valueStep}>
                    <View style={styles.contentRadioButton}>
                      <RadioButton value="1" />
                      <Text style={styles.description}>Até 50 mil</Text>
                    </View>
                    <View style={styles.contentRadioButton}>
                      <RadioButton value="2" />
                      <Text style={styles.description}>De 51 mil a 500 mil</Text>
                    </View>
                    <View style={styles.contentRadioButton}>
                      <RadioButton value="3" />
                      <Text style={styles.description}>De 501 mil a 1 milhão</Text>
                    </View>
                    <View style={styles.contentRadioButton}>
                      <RadioButton value="4" />
                      <Text style={styles.description}>De 1,1 milhão e um a 3 milhões</Text>
                    </View>
                    <View style={styles.contentRadioButton}>
                      <RadioButton value="5" />
                      <Text style={styles.description}>Mais de 3 milhões</Text>
                    </View>
                  </RadioButton.Group>
                </>
              )
            }

            {
              step === 11 && (
                <>
                  <Text style={styles.titleStep}>11. Quanto você pretende investir nos próximos 12 meses?</Text>
                  <RadioButton.Group onValueChange={newValue => setValueStep(newValue)} value={valueStep}>
                    <View style={styles.contentRadioButton}>
                      <RadioButton value="1" />
                      <Text style={styles.description}>Menos de R$ 5.000,00</Text>
                    </View>
                    <View style={styles.contentRadioButton}>
                      <RadioButton value="2" />
                      <Text style={styles.description}>Até R$ 10.000,00</Text>
                    </View>
                    <View style={styles.contentRadioButton}>
                      <RadioButton value="3" />
                      <Text style={styles.description}>Até R$ 100.000,00</Text>
                    </View>
                    <View style={styles.contentRadioButton}>
                      <RadioButton value="4" />
                      <Text style={styles.description}>Até R$ 500.000,00</Text>
                    </View>
                    <View style={styles.contentRadioButton}>
                      <RadioButton value="5" />
                      <Text style={styles.description}>Até R$ 1.000.000,00</Text>
                    </View>
                    <View style={styles.contentRadioButton}>
                      <RadioButton value="6" />
                      <Text style={styles.description}>Acima de R$ 1.000.000,00</Text>
                    </View>
                  </RadioButton.Group>
                </>
              )
            }
          </View>

          <View style={styles.contentBtns}>
            <TouchableOpacity style={styles.btn} onPress={prevStep}>
              <Text style={styles.textBtn}>Voltar</Text>
            </TouchableOpacity>
            {
              step === 11 ? (
                <TouchableOpacity style={styles.btn} onPress={handleSubmit}>
                  <Text style={styles.textBtn}>Finalizar</Text>
                </TouchableOpacity>
              ) : (
                <TouchableOpacity style={styles.btn} onPress={nextStep}>
                  <Text style={styles.textBtn}>Avançar</Text>
                </TouchableOpacity>
              )
            }
          </View>
        </>
        :
        <>
          <View style={styles.containerPerfil}>
            <Text style={styles.descriptionPerfil}>Seu perfil foi analisado:</Text>
            <Text style={styles.perfil}>{perfilAtual}</Text>
          </View>


          <View style={styles.contentBtns}>
            <TouchableOpacity style={styles.btn} onPress={() => { setStep(1); setFinalizado(false); }}>
              <Text style={styles.textBtn}>Refazer</Text>
            </TouchableOpacity>
            <TouchableOpacity style={styles.btn} onPress={() => navigation.navigate("Tabs")}>
              <Text style={styles.textBtn}>Sair</Text>
            </TouchableOpacity>
          </View>
        </>
      }
    </>
  );
}

export default InvestorProfile;